import { useState } from "react";
import { Breadcrumbs } from "../breadcrumbs";
import { CreateInviteForm } from "../forms/create-invite-form";
import { InvitesTable } from "../tables/invites-table";
import { Button } from "../ui/button";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "../ui/sheet";

export function InvitesPage() {
	const [open, setOpen] = useState(false);

	return (
		<div className="space-y-2">
			<Breadcrumbs />
			<Sheet open={open} onOpenChange={setOpen}>
				<div className="flex flex-col">
					<div className="flex justify-between">
						<h2>Invites</h2>
						<SheetTrigger render={<Button />}>Create Invite</SheetTrigger>
						<SheetContent>
							<SheetHeader>
								<SheetTitle>Create A New Invite</SheetTitle>
							</SheetHeader>
							<div className="px-4">
								<CreateInviteForm onComplete={() => setOpen(false)} />
							</div>
						</SheetContent>
					</div>
					<InvitesTable />
				</div>
			</Sheet>
		</div>
	);
}
